import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { setSelectedStore, setCountryStores } from "../../../redux/modules/auth/action";
import { USER_TYPES } from "@common/src/constants/constants";
import { ALL_OPTION } from "@pulse/constants/constants";
import { getCountryLabel } from "@common/src/common/helper";

const CountryStoresDrop = () => {
  const dispatch = useDispatch();

  const {
    stores = [],
    loading = true,
    user,
    selectedStore,
  } = useSelector((state) => state.auth || {});

  const [selectedCountry, setSelectedCountry] = useState(null);

  /**
   * Get unique countries
   */
  const countries = useMemo(() => {
    const list = [...new Set(stores.map((s) => s.country))];
    return list.map((c) => ({ label: getCountryLabel(c), value: c }));
  }, [stores]);

  /**
   * Filter stores based on selectedCountry
   */
  const filteredStores = useMemo(() => {
    if (!selectedCountry) return [];

    const list = stores.filter((s) => s.country === selectedCountry.value);

    let filteredList = [ALL_OPTION.stores, ...list];
    dispatch(setCountryStores({ stores: list, country: selectedCountry.value }));
    return filteredList;
  }, [selectedCountry, stores]);

  /**
   * Default Country + Store (ALL) on first load
   */
  useEffect(() => {
    if (!loading && stores.length > 0) {
      const defaultCountry = {
        label: getCountryLabel(stores[0].country),
        value: stores[0].country,
      };

      setSelectedCountry(defaultCountry);

      // Select ALL stores by default
      dispatch(setSelectedStore(ALL_OPTION.stores));
    }
  }, [loading, stores, dispatch]);

  /**
   * When user changes country
   */
  const handleCountryChange = (countryObj) => {
    setSelectedCountry(countryObj);

    // After choosing a country → always select ALL
    dispatch(setSelectedStore(ALL_OPTION.stores));
  };

  return (
    <>
      {!loading && user?.userType === USER_TYPES.PULSE_SUB_ADMIN && (
        <>
          {/* COUNTRY DROPDOWN */}
          <Select
            className="ti-form-select rounded-sm !p-0 min-w-[300px] mr-2 mob-drop-120"
            placeholder="Choose Country"
            options={countries}
            value={selectedCountry}
            onChange={handleCountryChange}
          />

          {/* STORE DROPDOWN */}
          <Select
            className="ti-form-select rounded-sm !p-0 min-w-[300px] mob-drop-120"
            placeholder="Choose Store"
            options={filteredStores}
            value={selectedStore || filteredStores?.[0]}
            onChange={(obj) => dispatch(setSelectedStore(obj))}
            getOptionLabel={(s) => s.label}
            getOptionValue={(s) => s.value}
          />
        </>
      )}
    </>
  );
};

export default CountryStoresDrop;
